import React from "react";
import ReactDOM from "react-dom/client";
import 'sweetalert2/src/sweetalert2.scss'

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();

